import Vue from 'vue';

import sentry from '@/config/sentry';

import '@/config/fields';
import '@/config/font-awesome';

import filters from '@/helpers/filters/_install';

import router from './router';
import store from './store';

import App from './App.vue';

sentry(router);

Vue.use(filters);
Vue.config.productionTip = false;

const id = process.env.VUE_APP_ROOT_ID;

if (document.getElementById(id)) {
  const CREDERE_PWA = new Vue({
    render: h => h(App),
    router,
    store,
  }).$mount(`#${id}`);

  window.CREDERE_PWA = CREDERE_PWA;
}
